import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  avatar: string | null;
}

const initialState: UserState = {
  avatar: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAvatar(state, action: PayloadAction<{avatar: string}>) {
      state.avatar = action.payload.avatar;
    }
  },
});

export const { setAvatar } = userSlice.actions;
export default userSlice.reducer;